import React from 'react';

const Hero = ({ title }) => {
  return (
    <div className='hero'>
      <div className='container mx-auto px-4 flex items-center h-full'>
        <div className='text-white bg-blue-500 px-6 py-3 text-lg uppercase'>
          {title}
        </div>
      </div>
    </div>
  );
};

export default Hero;
